import React, { Component } from 'react';

class MultiEmailInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            inputValue: '',
        };
        this.inputRef = React.createRef();
    }

    isValidEmail = email => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    };

    addEmails = emailsToAdd => {
        const { value, max, onChange } = this.props;
        const currentEmails = value || [];
        const newEmails = [...currentEmails];
        let added = false;

        let availableSlots = max ? max - currentEmails.length : Infinity;

        emailsToAdd.forEach(email => {
            if (availableSlots <= 0) return;

            const trimmed = email.trim();
            if (this.isValidEmail(trimmed) && !newEmails.includes(trimmed)) {
                newEmails.push(trimmed);
                added = true;
                availableSlots--;
            }
        });

        if (added) {
            this.setState({ inputValue: '' });
            onChange(newEmails);
        } else {
            this.setState({ inputValue: '' });
        }
    };

    removeEmail = indexToRemove => {
        if (this.props.disabled) return;

        const currentEmails = this.props.value || [];
        const newEmails = currentEmails.filter((_, index) => index !== indexToRemove);
        this.props.onChange(newEmails);
    };

    handleKeyDown = e => {
        const { inputValue } = this.state;
        const currentEmails = this.props.value || [];

        if (['Enter', 'Tab', ','].includes(e.key)) {
            e.preventDefault();
            if (inputValue) this.addEmails(inputValue.split(','));
        }

        if (e.key === ' ' && inputValue) {
            e.preventDefault();
        }

        if (e.key === 'Backspace' && !inputValue && currentEmails.length > 0) {
            this.removeEmail(currentEmails.length - 1);
        }
    };

    handleChange = e => {
        this.setState({ inputValue: e.target.value });
    };

    handleBlur = () => {
        if (this.state.inputValue) {
            this.addEmails(this.state.inputValue.split(','));
        }
        if (this.props.onBlur) {
            this.props.onBlur();
        }
    };

    handlePaste = e => {
        e.preventDefault();
        const paste = e.clipboardData.getData('text');
        const emailsToAdd = paste.split(/[\s,;\n]+/);
        this.addEmails(emailsToAdd);
    };

    render() {
        const { inputValue } = this.state;
        const { disabled, placeholder, value, max } = this.props;
        const emails = value || [];

        const isMaxReached = max && emails.length >= max;

        const styles = {
            container: {
                display: 'flex',
                flexWrap: 'wrap',
                border: '1px solid #d9d9d9',
                padding: '4px',
                borderRadius: '4px',
                alignItems: 'center',
                minHeight: '40px',
                cursor: disabled ? 'not-allowed' : 'text',
                backgroundColor: disabled ? '#f5f5f5' : '#fff',
            },
            chip: {
                display: 'flex',
                alignItems: 'center',
                backgroundColor: '#e0e0e0',
                borderRadius: '16px',
                padding: '4px 10px',
                margin: '4px',
                fontSize: '14px',
            },
            closeBtn: {
                marginLeft: '8px',
                cursor: disabled ? 'not-allowed' : 'pointer',
                fontWeight: 'bold',
                color: '#777',
            },
            input: {
                border: 'none',
                outline: 'none',
                flexGrow: 1,
                padding: '4px 8px',
                fontSize: '14px',
                minWidth: '150px',
                backgroundColor: 'transparent',
                display: isMaxReached ? 'none' : 'block',
            },
        };

        return (
            <div style={styles.container} onClick={() => !disabled && !isMaxReached && this.inputRef.current.focus()}>
                {emails.map((email, index) => (
                    <div key={email} style={styles.chip}>
                        {email}
                        {!disabled && (
                            <span
                                style={styles.closeBtn}
                                onClick={e => {
                                    e.stopPropagation();
                                    this.removeEmail(index);
                                }}>
                                &times;
                            </span>
                        )}
                    </div>
                ))}

                {!isMaxReached && (
                    <input
                        ref={this.inputRef}
                        style={styles.input}
                        value={inputValue}
                        onChange={this.handleChange}
                        onKeyDown={this.handleKeyDown}
                        onBlur={this.handleBlur}
                        onPaste={this.handlePaste}
                        disabled={disabled}
                        placeholder={emails.length === 0 ? placeholder : ''}
                    />
                )}
            </div>
        );
    }
}

export default MultiEmailInput;
